import consumerActions from '../actions/consumer/consumer';

const initialState = {
  email: null,
  name: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case consumerActions.SET_EMAIL:
      return {
        ...state,
        email: action.email
      };
    case consumerActions.SET_RECOMMENDATIONS:
      return {
        ...state,
        plans: action.plans
      };
    case consumerActions.REMOVE_EMAIL:
      return {
        ...state,
        email: null
      };
    case consumerActions.SET_NAME:
      return {
        ...state,
        name: action.name
      };
    default:
      return state;
  }
};
